import { Component, memo } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  INDICATOR_GROUP_ID,
  INDICATOR_GROUPS,
  INDICATORS,
  PROGRAM_ID_LIST,
  PROGRAM_SELECTION
} from "../../../../ducks/indicatorGroup";

import { faExclamationTriangle, faFilter, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import find from "lodash/find";
import PropTypes from "prop-types";
import { Accordion, AccordionCollapse, Card, Dropdown, FormGroup, Nav, NavItem, NavLink, Row } from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import DropdownItem from "react-bootstrap/DropdownItem";
import DropdownMenu from "react-bootstrap/DropdownMenu";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import BootstrapTable from "react-bootstrap/Table";
import * as uuid from "uuid";
import { ChartColors } from "../../../../common/constant";
import { PROGRAM_INSTANCE_FOREIGN_IDS } from "../../../../ducks/indicatorGroup";
import { processCheckboxLabel } from "../../../../utils/OptionsUtils";
import AccordionCardHeaderToggle from "../../../common/AccordionToggleButton";
import Checkbox from "../../../common/Checkbox";
import StandardView from "../../../common/StandardView";
import FundingAreaContainer from "../../fundingArea/FundingAreaContainer";
import IndicatorChart from "./IndicatorChart";

export const LegendTable = memo((props) => {
  return (
    <BootstrapTable striped bordered size="sm" className="my-3">
      <thead>
        <tr>
          <th colSpan={2}>
            <FormattedMessage id="indicator.chart.legend" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th className="shrink text-center">N</th>
          <td>
            <FormattedMessage id="indicator.chart.legend.report.amount" />
          </td>
        </tr>
        <tr>
          <th className="shrink text-center">n</th>
          <td>
            <FormattedMessage id="indicator.chart.legend.project.amount" />
          </td>
        </tr>
        <tr>
          <th className="shrink text-center">∑</th>
          <td>
            <FormattedMessage id="indicator.chart.legend.results.sum" />
          </td>
        </tr>
      </tbody>
    </BootstrapTable>
  );
});

class Charts extends Component {
  constructor(props) {
    super(props);
    this.renderIndicatorGroups = this.renderIndicatorGroups.bind(this);
    this.handleClickIndicatorGroup = this.handleClickIndicatorGroup.bind(this);
    this.handleSelectTimeFacet = this.handleSelectTimeFacet.bind(this);
    this.handleSelectProgramInstanceFacet = this.handleSelectProgramInstanceFacet.bind(this);
    this.handleSelectStatus = this.handleSelectStatus.bind(this);
    this.renderIndicatorDescription = this.renderIndicatorDescription.bind(this);

    this.state = {
      status: "SENT",
      showIndicatorGroupRequiredMessage: false,
      changedFilterCriteria: false,
      programSelection: props.programSelection || {},
      programIdList: props.programIdList || []
    };
  }

  componentDidMount() {
    this.props.getTimeFacetForEvaluation();
  }

  componentDidUpdate(prevProps) {
    const { 
      loadIndicatorGroups, 
      propertyChange, 
      loadIndicatorGroupData, 
      timeFacet, 
      label, 
      selectedFundingArea, 
      selectedProgram, 
      groupId 
    } = this.props;

    const selectedFundingAreaId =
      selectedFundingArea && selectedFundingArea.indicatorGroup ? selectedFundingArea.indicatorGroup.id : null;
    const oldSelectedFundingAreaId =
      prevProps.selectedFundingArea && prevProps.selectedFundingArea.indicatorGroup
        ? prevProps.selectedFundingArea.indicatorGroup.id
        : null;
    let selectedProgramId =
      selectedProgram && selectedProgram.indicatorGroup ? selectedProgram.indicatorGroup.id : null;
    const oldSelectedProgramId =
      prevProps.selectedProgram && prevProps.selectedProgram.indicatorGroup
        ? prevProps.selectedProgram.indicatorGroup.id
        : null;
    const selectedYears = label ? [...label] : [];

    let programForeignIds;

    if (selectedProgram && selectedProgram.indicatorGroup) {
      programForeignIds = selectedProgram.indicatorGroup.foreignId;
    } else {
      programForeignIds = this.state.programIdList.length > 0 ? this.state.programIdList.join(",") : null;
    }

    const { status } = this.state;

    const filterChanged =
      selectedFundingAreaId !== oldSelectedFundingAreaId ||
      selectedProgramId !== oldSelectedProgramId ||
      groupId !== prevProps.groupId;

    if (filterChanged) {
      if (selectedFundingAreaId !== null) {
        let selectedFacets = [];
        if (timeFacet) {
          selectedFacets = timeFacet.facets.filter((facet) => selectedYears.indexOf(facet.label) > -1);
        }
        if (selectedFundingAreaId && selectedFundingAreaId !== oldSelectedFundingAreaId) {
          propertyChange(INDICATORS, null);
          propertyChange(INDICATOR_GROUPS, null);
          loadIndicatorGroups(selectedFundingAreaId);
        } else if (groupId && oldSelectedProgramId && !selectedProgramId) {
          propertyChange(INDICATORS, null);
          selectedProgramId = null; //refId not used anymore?
          loadIndicatorGroupData(groupId, null, status, selectedFacets, programForeignIds);
        } else if (groupId && selectedProgramId !== oldSelectedProgramId) {
          propertyChange(INDICATORS, null);
          selectedProgramId = null; //refId not used anymore?
          loadIndicatorGroupData(groupId, selectedProgramId, status, selectedFacets, programForeignIds);
        }
      } else {
        propertyChange(INDICATORS, null);
        propertyChange(INDICATOR_GROUPS, null);
        propertyChange(INDICATOR_GROUP_ID, null);
      }
    }
  }

  handleApplyFilterCriteria = () => {
    const { loadIndicatorGroupData, propertyChange, timeFacet, groupId, selectedProgram } = this.props;
    const selectedProgramId = null; //selectedProgram && selectedProgram.indicatorGroup ?
    // selectedProgram.indicatorGroup.id : null;
    const { status } = this.state;
    const selectedYears = this.props.label ? [...this.props.label] : [];
    let programForeignIds;

    if (selectedProgram && selectedProgram.indicatorGroup) {
      programForeignIds = selectedProgram.indicatorGroup.foreignId;
    } else {
      programForeignIds =
        this.state.programIdList.length > 0
          ? this.state.programIdList
              .filter((pId) => this.state.programSelection[pId] === undefined || this.state.programSelection[pId])
              .join(",")
          : null;
    }

    if (groupId) {
      const selectedFacets = timeFacet.facets.filter((facet) => selectedYears.indexOf(facet.label) > -1);

      if (selectedFacets) {
        propertyChange(PROGRAM_SELECTION, this.state.programSelection);
        propertyChange(PROGRAM_ID_LIST, this.state.programIdList);
        this.setState({ changedFilterCriteria: false });
        loadIndicatorGroupData(
          groupId,
          selectedProgramId,
          status,
          selectedFacets,
          programForeignIds
        );
      }
    }
  };

  handleSelectTimeFacet(event) {
    const { yearsChange } = this.props;
    const selected = event.target.checked;
    const yearLabel = event.target.name;
    let selectedYears = this.props.label ? [...this.props.label] : [];

    if (selected) {
      selectedYears.push(yearLabel);
      yearsChange(selectedYears);
    } else {
      selectedYears = selectedYears.filter((year) => year !== yearLabel);
      yearsChange(selectedYears);
    }

    this.setState({
      showIndicatorGroupRequiredMessage: selectedYears.length === 0,
      changedFilterCriteria: true
    });
  }

  handleSelectProgramInstanceFacet(event, allProgramInstances) {
    const {
      propertyChange,
      programInstanceForeignIds
    } = this.props;
    let selectedInstanceIds = programInstanceForeignIds ? [...programInstanceForeignIds] : [];
    if (allProgramInstances) {
      propertyChange(
        PROGRAM_INSTANCE_FOREIGN_IDS,
        allProgramInstances.map((pi) => pi.id)
      );
      this.setState({changedFilterCriteria: true});
    } else {
      const selected = event.target.checked;
      const id = event.target.value;

      if (selected) {
        selectedInstanceIds.push(id);
      } else {
        selectedInstanceIds = selectedInstanceIds.filter((instanceId) => instanceId !== id);
      }

      propertyChange(PROGRAM_INSTANCE_FOREIGN_IDS, selectedInstanceIds);
      if (selectedInstanceIds.length) {
        this.setState({changedFilterCriteria: true});
      }
    }
  }

  handleSelectStatus(event) {
    const selected = event.target.checked;
    const status = selected ? "SENT" : undefined;

    this.setState({
      status,
      changedFilterCriteria: true
    });
  }

  handleClickIndicatorGroup(groupId) {
    const { loadIndicatorGroupData, timeFacet, label, selectedProgram, propertyChange } =
      this.props;
    const selectedProgramId = null; //selectedProgram && selectedProgram.indicatorGroup ?
    // selectedProgram.indicatorGroup.id : null;
    let programForeignIds;

    if (selectedProgram && selectedProgram.indicatorGroup) {
      programForeignIds = selectedProgram.indicatorGroup.foreignId;
    } else {
      programForeignIds =
        this.state.programIdList.length > 0
          ? this.state.programIdList
              .filter((pId) => this.state.programSelection[pId] === undefined || this.state.programSelection[pId])
              .join(",")
          : null;
    }

    const { status } = this.state;

    propertyChange(INDICATOR_GROUP_ID, groupId);

    if (label !== null && label.length > 0) {
      this.setState({ showIndicatorGroupRequiredMessage: false });
      const selectedFacets = timeFacet.facets.filter((facet) => label.indexOf(facet.label) > -1);
      propertyChange(PROGRAM_SELECTION, this.state.programSelection);
      propertyChange(PROGRAM_ID_LIST, this.state.programIdList);
      this.setState({ changedFilterCriteria: false });
      loadIndicatorGroupData(
        groupId,
        selectedProgramId,
        status,
        selectedFacets,
        programForeignIds
      );
    } else {
      this.setState({ showIndicatorGroupRequiredMessage: true });
    }
  }

  handleToggleAllProgramCheckboxes = (checked) => {
    const { indicators } = this.props;

    const allFalse = indicators.programForeignIds.reduce((accumulator, currentKey) => {
      accumulator[currentKey.foreignId] = false;
      return accumulator;
    }, {});

    this.setState({
      ...this.state,
      programSelection: checked ? {} : allFalse,
      programIdList: checked ? [] : Object.keys(allFalse),
      changedFilterCriteria: true
    });
  };

  allProgramsSelected = () => {
    return !Object.values(this.state.programSelection).some((v) => v === false);
  };

  getAvailableProgramForeignIds = () => {
    const { indicators, selectedFundingArea } = this.props;

    const programs =
      indicators?.programForeignIds ||
      selectedFundingArea?.indicatorGroup?.programs ||
      [];

    return programs.map((program) => program.foreignId).filter(Boolean);
  };

  handleProgramCheckboxClicked = (event) => {
    const programSelection = {
      ...this.state.programSelection,
      [event.target.value]: event.target.checked
    };

    this.setState({
      ...this.state,
      programSelection: programSelection,
      programIdList: this.getAvailableProgramForeignIds()
        .filter((programId) => !(programSelection[programId] === false)),
      changedFilterCriteria: true
    });
  };

  handleClickDownload = () => {
    const { downloadIndicatorCSV, label, timeFacet, groupId, selectedProgram, indicators } =
      this.props;
    let programForeignIds;

    if (selectedProgram && selectedProgram.indicatorGroup) {
      programForeignIds = selectedProgram.indicatorGroup.foreignId;
    } else {
      programForeignIds =
        this.state.programIdList.length > 0
          ? this.state.programIdList
              .filter((pId) => this.state.programSelection[pId] === undefined || this.state.programSelection[pId])
              .join(",")
          : null;
    }

    const { status } = this.state;
    let groupName = indicators ? indicators.groupName : undefined;
    let selectedYears = label ? [...label] : [];

    if (groupId) {
      const selectedFacets = timeFacet.facets.filter((facet) => selectedYears.indexOf(facet.label) > -1);
      let fileName = "Indikator_" + groupName;
      selectedYears.forEach((year) => {
        fileName = fileName + "_" + year;
      });
      if (selectedFacets) {
        downloadIndicatorCSV(
          groupId,
          null,
          status,
          selectedFacets,
          programForeignIds,
          fileName
        );
      }
    }
  };

  handleClickDownloadTexts = () => {
    const { downloadIndicatorCSV, timeFacet, label } = this.props;

    const { status } = this.state;

    const facet = find(timeFacet.facets, { label });
    const from = facet ? facet.startTime : undefined;
    const to = facet ? facet.endTime : undefined;

    downloadIndicatorCSV(status, from, to, "Comment");
  };

  handleClickDownloadZip = () => {
    const { downloadIndicatorCSV, timeFacet, label } = this.props;

    const { status } = this.state;

    const facet = find(timeFacet.facets, { label });
    const from = facet ? facet.startTime : undefined;
    const to = facet ? facet.endTime : undefined;

    downloadIndicatorCSV(status, from, to, "", "", undefined, true);
  };

  renderIndicatorDescription = (indicators, label, noOtherWarnings) => {
    const instance = this;

    let nodes = [];
    let programs = [];

    let indicatorList = indicators.indicators;

    let description = indicators.description || "";

    if (indicatorList && indicatorList instanceof Array && indicatorList.length > 0) {
      let indicator = indicatorList[0];
      if (indicator.visualizations && indicator.visualizations.length > 0) {
        let statistic = indicator.visualizations[0].statistic;
        let total1 = -1;
        let total2 = -1;
        let total3 = -1;
        let total4 = -1;
        let indexOfYear = -1;

        if (statistic && statistic.length > 0) {
          statistic.forEach(function (row) {
            let isHeader = row.indexOf("TOTAL") > -1;
            if (isHeader) {
              total1 = row.indexOf("N");
              total2 = row.indexOf("n");
              total3 = row.indexOf("TOTAL");
              total4 = row.indexOf("P");
              indexOfYear = row.indexOf("PGLIST");
            } else {
              if (row.length > 3) {
                description = description.replace("TOTAL1", row[total1].toString());
                description = description.replace("TOTAL2", row[total2].toString());
                description = description.replace("TOTAL3", row[total3].toString());
                description = description.replace("TOTAL4", row[total4].toString());
                if (row[indexOfYear]) {
                  let list = row[indexOfYear];
                  let year = [];
                  if (list instanceof Array && list.length > 0) {
                    list.forEach(function (listItem) {
                      if (!year.includes(listItem.year.toString())) {
                        year.push(listItem.year.toString());
                      }
                    });
                  }
                  description = description.replace("YEAR", year.toString());
                  description = year.length > 1 ? description.replace("im Jahr", "in den Jahren") : description;
                  //TODO: dirty hack to add spaces between years!
                  description = description.replace(/(,2)/g, ", 2");

                  const found = label.filter((value) => year.includes(value));
                  if (noOtherWarnings && found?.length > 0 && found.length !== label.length) {
                    nodes.push(
                      <Alert key="alert" variant="warning">
                        <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                        <FormattedMessage id="collapsible.filter.reportingYear.warning" />{" "}
                        {year.toString().replace(/(,2)/g, ", 2")}
                      </Alert>
                    );
                  }
                }
              }
            }
          });
        }
      }
      nodes.push(<h3 key={"heading"}>{indicators.groupName}</h3>);
      if (this.props.selectedFundingArea.indicatorGroup && this.props.selectedFundingArea.indicatorGroup.programs) {
        let programList;
        if (this.props.selectedProgram && this.props.selectedProgram.indicatorGroup) {
          programList = [this.props.selectedProgram.indicatorGroup];
        } else {
          programList = indicators.programForeignIds || [];
        }
        const hasProg = !!(this.props.selectedProgram && this.props.selectedProgram.indicatorGroup);
        programs = programList.map((program, i) => (
          <Checkbox
            key={i}
            type="checkbox"
            value={program.foreignId}
            onChange={instance.handleProgramCheckboxClicked}
            disabled={hasProg}
            checked={
              hasProg ||
              instance.state.programSelection[program.foreignId] === undefined ||
              instance.state.programSelection[program.foreignId]
            }
          >
            {program.name} ({program.foreignId})
          </Checkbox>
        ));
      }
    }

    const pglistPlaceholderStartIndex = description.indexOf("PGLIST");

    if (pglistPlaceholderStartIndex > -1) {
      const beforeProgramList = description.substr(0, description.indexOf("PGLIST"));
      const afterProgramList = description.substr(description.indexOf("PGLIST") + 6);

      nodes.push(<div key={"description1"} dangerouslySetInnerHTML={{ __html: beforeProgramList }} />);
      if (programs.length > 1) {
        nodes.push(
          <Checkbox
            key="toggleAllCheckbox"
            className="my-3"
            type="checkbox"
            onChange={(e) => instance.handleToggleAllProgramCheckboxes(e.target.checked)}
            checked={instance.allProgramsSelected()}
          >
            {this.props.intl.formatMessage({ id: "app.common.action.toggle.all" })}
          </Checkbox>
        );
      }
      nodes.push(...programs);
      nodes.push(<div key={"description2"} dangerouslySetInnerHTML={{ __html: afterProgramList }} />);
    } else {
      description = description.replace("k.A.");
      nodes.push(<div key={"description"} dangerouslySetInnerHTML={{ __html: description }} />);
    }

    return nodes;
  };

  resetColor(indicator) {
    //overwrite color schema with predefined set of colors
    let options = indicator.visualizations[0].options;
    indicator.visualizations[0].options = {
      ...options,
      colors: ChartColors
    };
  }

  render() {
    const { 
      indicatorGroups, 
      indicators, 
      timeFacet, 
      label, 
      intl, 
      groupId,
      selectedFundingArea, 
      selectedProgram, 
      programInstanceForeignIds 
    } = this.props;

    const programInstances = selectedProgram?.indicatorGroup?.programInstances;

    return (
      <StandardView id="charts" titleKey="evaluation.tabs.indicators">
        <FundingAreaContainer
          target="indicatorGroup"
          faFilter={(fa) => fa?.foreignId === "BMZ"}
          preventProjectChoice
          preventProgramInstance
        />
        <Row className="my-4">
          <Col lg={2} md={2} sm={3} className="mt-n3">
            {indicatorGroups?.length > 0 && (
              <fieldset className="border">
                <legend className="w-auto px-2 ms-1">
                  <FormattedMessage id="evaluation.tabs.indicators" />
                </legend>
                <Nav className="flex-column">{indicatorGroups.map(this.renderIndicatorGroups)}</Nav>
              </fieldset>
            )}
          </Col>
          <Col lg={8} md={7} sm={5}>
            {!selectedFundingArea?.indicatorGroup && (
              <Alert variant="info text-dark">
                <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                <FormattedMessage id="indicator.chart.choose.funding.area" />
              </Alert>
            )}
            {selectedFundingArea?.indicatorGroup && !groupId && (
              <Alert variant="info text-dark">
                <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                <FormattedMessage id="indicator.chart.choose.group" />
              </Alert>
            )}
            {selectedFundingArea?.indicatorGroup && groupId && this.state.showIndicatorGroupRequiredMessage && (
              <Alert variant="info text-dark">
                <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                <FormattedMessage id="collapsible.year.required" />
              </Alert>
            )}
            {groupId && !this.state.showIndicatorGroupRequiredMessage && this.state.changedFilterCriteria && (
              <Alert variant="warning">
                <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                <FormattedMessage id="indicator.chart.changed.filter.criteria" />
              </Alert>
            )}
            {indicators ? (
              <>
                <div>
                  {this.renderIndicatorDescription(
                    indicators,
                    label,
                    !this.state.showIndicatorGroupRequiredMessage && !this.state.changedFilterCriteria
                  )}
                </div>
                {indicators.indicators &&
                  indicators.indicators.map((indicator) => {
                    this.resetColor(indicator);
                    return <IndicatorChart key={uuid.v4()} indicator={indicator} />;
                  })}
              </>
            ) : (
              indicators?.indicators?.length &&
              groupId &&
              !this.state.changedFilterCriteria && (
                <Alert variant="secondary">
                  <FormattedMessage id="collapsible.table.nodata" />
                </Alert>
              )
            )}
          </Col>
          <Col lg={2} md={3} sm={4}>
            <Button
              disabled={!selectedFundingArea?.indicatorGroup || !groupId}
              onClick={this.handleApplyFilterCriteria}
              className="w-100"
            >
              <FontAwesomeIcon icon={faFilter} className="me-2" />
              <FormattedMessage id="indicator.chart.apply.filters" />
            </Button>
            {timeFacet && (
              <Accordion className="my-3" defaultActiveKey="year-facet">
                <Card>
                  <AccordionCardHeaderToggle label="collapsible.filter.reportingYear" eventKey="year-facet" />
                  <AccordionCollapse eventKey="year-facet">
                    <Card.Body className="pb-0">
                      {timeFacet.facets.map((checkBox, index) => (
                        <FormGroup className="mb-3" key={index}>
                          <Checkbox
                            name={checkBox.label}
                            value={checkBox.label}
                            type="checkbox"
                            onChange={this.handleSelectTimeFacet}
                            defaultChecked={label && label.indexOf(checkBox.label) > -1}
                          >
                            {checkBox.label}
                          </Checkbox>
                        </FormGroup>
                      ))}
                    </Card.Body>
                  </AccordionCollapse>
                </Card>
              </Accordion>
            )}

            {programInstances && (
              <Accordion className="mb-3" defaultActiveKey="instance-facet">
                <Card>
                  <AccordionCardHeaderToggle
                    label="master.data.management.program.instance"
                    eventKey="instance-facet"
                    onReset={(e) => this.handleSelectProgramInstanceFacet(e, programInstances)}
                  />
                  <AccordionCollapse eventKey="instance-facet">
                    <Card.Body className="pb-0">
                      {programInstances.map((progInst, index) => (
                        <FormGroup className="mb-3" key={index}>
                          <Checkbox
                            type="checkbox"
                            value={progInst.id}
                            onChange={this.handleSelectProgramInstanceFacet}
                            checked={programInstanceForeignIds && programInstanceForeignIds.indexOf(progInst.id) > -1}
                            title={progInst.name}
                          >
                            {processCheckboxLabel(progInst)}
                          </Checkbox>
                        </FormGroup>
                      ))}
                    </Card.Body>
                  </AccordionCollapse>
                </Card>
              </Accordion>
            )}

            <FormGroup  className="mb-3">
              <Checkbox
                name="status"
                onChange={this.handleSelectStatus}
                defaultChecked={this.state.status === "SENT"}
                type="checkbox"
              >
                {intl.formatMessage({ id: "collapsible.filter.status" })}
              </Checkbox>
            </FormGroup>
            {/*<div className="status__facet">
                         <Checkbox
                         id={"finalReport"}
                         name={"finalReport"}
                         type={"checkbox"}
                         >
                         {intl.formatMessage({"id": "collapsible.filter.finalReport"})}
                         </Checkbox>
                         </div>*/}
            <Dropdown>
              <DropdownToggle className="w-100">
                <FormattedMessage id="app.common.Export" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem disabled={!this.props.groupId} onClick={this.handleClickDownload}>
                  <FormattedMessage id="collapsible.download.downloadAll" />
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <LegendTable />
          </Col>
        </Row>
      </StandardView>
    );
  }

  // rendering of indicator groups
  renderIndicatorGroups(indicatorGroup) {
    return (
      <NavItem key={indicatorGroup.id}>
        <NavLink
          active={indicatorGroup.id === this.props.groupId}
          onClick={() => this.handleClickIndicatorGroup(indicatorGroup.id)}
        >
          {indicatorGroup.name}
        </NavLink>
      </NavItem>
    );
  }
}

Charts.propTypes = {
  intl: PropTypes.object,
  indicatorGroups: PropTypes.array,
  groupId: PropTypes.string,
  propertyChange: PropTypes.func,
  removeDataForAnalyticsReport: PropTypes.func,
  clearCharts: PropTypes.func,
  getTimeFacetForEvaluation: PropTypes.func,
  loadIndicatorGroupData: PropTypes.func,
  loadIndicatorGroups: PropTypes.func,
  timeFacet: PropTypes.object,
  checked: PropTypes.bool,
  label: PropTypes.array,
  downloadIndicatorCSV: PropTypes.func
};

export default injectIntl(Charts);
